document.addEventListener("DOMContentLoaded", () => {
  (function () {
    const currentPath = window.location.pathname;
    if (currentPath.includes("/sign-in") || currentPath.includes("/sign-up")) {
      return;
    }

    function setReturnToCookie() {
      setCookie("return_to", window.location.pathname + window.location.search, 365);
    }

    setReturnToCookie();
    updateLoginLinks();

    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      setReturnToCookie();
      updateLoginLinks();
    };
  })();
});
